import { Dispatch } from 'redux';
import { ActionType } from '../action-types';
import { Action } from '../actions';
import { BatuWS } from '../../batu/impl/BatuWebsockets';
import { RPURequestItem } from '../../models/types';

export const updateRPU = (rpu: string) => {
  return (dispatch: Dispatch<Action>) => {
    dispatch({
      type: ActionType.UPDATE_RPU,
      payload: rpu,
    });
  };
};
export const addRpuToRequestedBills = (bill: BatuWS) => {
  return (dispatch: Dispatch<Action>) => {
    dispatch({
      type: ActionType.ADD_RPU_TO_REQUESTED_BILLS,
      payload: bill,
    });
  };
};
export const updateMassUploadFile = (file: File | null) => {
  return (dispatch: Dispatch<Action>) => {
    dispatch({
      type: ActionType.UPDATE_MASS_UPLOAD_FILE,
      payload: file,
    });
  };
};
export const updateMassUploadRpuList = (list: RPURequestItem[]) => {
  return (dispatch: Dispatch<Action>) => {
    dispatch({
      type: ActionType.UPDATE_MASS_UPLOAD_RPU_LIST,
      payload: list,
    });
  };
};
